import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import EditForm from '../../../features/components/Forms/EditForm'

import { clearUpdateCampaign } from '../../../modules/actions/campaigns'
import {
  campaignUpdateErrorSelector,
  campaignUpdateIsLoadingSelector,
  campaignWasUpdatedSelector
} from '../../../modules/selectors/campaigns'

const CampaignEditForm = ({ children, initialValues, formik, ...formProps }) => {
  const dispatch = useDispatch()

  const successUpdate = useSelector(campaignWasUpdatedSelector)

  const handleClearUpdateCampaign = useCallback(() => {
    dispatch(clearUpdateCampaign())
  }, [dispatch])

  return (
    <EditForm
      formik={formik}
      initialValues={initialValues}
      successSubmit={successUpdate}
      clearEditItem={handleClearUpdateCampaign}
      errorSelector={campaignUpdateErrorSelector}
      isLoadingSelector={campaignUpdateIsLoadingSelector}
      {...formProps}
    >
      {children}
    </EditForm>
  )
}

CampaignEditForm.propTypes = {
  CampaignFormFields: PropTypes.node.isRequired,
  initialValues: PropTypes.object.isRequired,
  formik: PropTypes.object.isRequired
}

export default CampaignEditForm
